module.exports = __webpack_public_path__ + "img/votes_icon.0deaafcf.png";